import { AirbnbRating, makeStyles } from '@rneui/themed'
import { StyleProp } from 'react-native/Libraries/StyleSheet/StyleSheet'
import { ViewStyle } from 'react-native/Libraries/StyleSheet/StyleSheetTypes'

interface Props {
  count?: number
  isDisabled?: boolean
  size?: number
  defaultRating?: number
  reviews?: string[]
  onFinishRating: (rating: number) => void
  containerStyles?: StyleProp<ViewStyle>
}

export function Rating({
  count,
  isDisabled,
  size,
  defaultRating,
  reviews,
  onFinishRating,
  containerStyles,
}: Props) {
  const styles = useStyles()
  return (
    <AirbnbRating
      count={count}
      reviewColor={styles.reviewColor.color}
      selectedColor={styles.selectedColor.color}
      size={size}
      defaultRating={defaultRating}
      isDisabled={isDisabled}
      ratingContainerStyle={containerStyles}
      starContainerStyle={styles.starContainer}
      reviewSize={reviews ? 14 : 0}
      reviews={reviews ?? []}
      onFinishRating={rating => onFinishRating(rating)}
    />
  )
}

const useStyles = makeStyles(theme => ({
  starContainer: {
    justifyContent: 'space-between',
  },
  reviewColor: {
    color: theme.colors?.black,
  },
  selectedColor: {
    color: theme.colors?.primary,
  },
}))
